import { TidStatusDto } from "../models/TidStatusDto";
import { UserType } from "./UserTypeEnum";
import _ from 'lodash';

export class Mapper {
  static checkMandatoryParams(params: object) {
    var requiredKeys = ['userType'];
    return _.every(requiredKeys, _.partial(_.has, params));
  }

  static mapParamToUserType(param: string): UserType {
    try {
      let value = parseInt(param);
      console.log("[Mapper] mapParamToUserType -> " + value);
      switch (value) {
        case 0:
          return UserType.ADMIN;
        case 1:
          return UserType.STAFF;
        case 2:
          return UserType.DEVELOPER;

        default:
          return UserType.STAFF;
      }
    } catch (error) {
      return UserType.STAFF;
    }
  }

  static mapParamToTerminalStatus(param: string): TidStatusDto {
    if (param === undefined) {
      return TidStatusDto.NOT_ASSIGNED;
    } else {
      if (param === "ATTIVO") {
        return TidStatusDto.ACTIVE;
      } else if (param === "SOSPESO") {
        return TidStatusDto.SUSPENDED;
      } else {
        return TidStatusDto.NOT_ASSIGNED;
      }
    }
  }

  static checkCategoryMandatoryParams(params: object) {
    var requiredKeys = ['color', 'name'];
    return _.every(requiredKeys, _.partial(_.has, params));
  }

  static checkProductMandatoryParams(params: object) {
    var requiredKeys = ['hasImage', 'name'];
    return _.every(requiredKeys, _.partial(_.has, params));
  }

  static mapItalianParamToUserType(param: string | null): UserType {
    try {
      let value = param ?? "";
      console.log("[Mapper] mapItalianParamToUserType -> " + value);
      switch (value) {
        case "AMMINISTRATORE":
          return UserType.ADMIN;
        case "DIPENDENTE":
          return UserType.STAFF;
        case "SVILUPPATORE":
          return UserType.DEVELOPER;
        default:
          return UserType.STAFF;
      }
    } catch (error) {
      return UserType.STAFF;
    }
  }
}